module.exports = __webpack_public_path__ + "img/shouhuodizhi.fa9ba6c2.png";